import React from 'react'
import { StyledSwitch } from './switchClass'
import './switch.scss'

function CustomSwitch(props) {
  const { name, value, sectionActiveChange, disabled, useYesNoButtons } = props

  return (
    <>
      <StyledSwitch
        name={name}
        value={value}
        color="default"
        onClick={sectionActiveChange}
        checked={value}
        inputProps={{ 'aria-label': 'primary checkbox' }}
        disabled={Boolean(disabled)}
        classes={useYesNoButtons ? {
          thumb: 'switch-thumb-yesno',
          track: 'switch-track-yesno',
        } : undefined}
      />
    </>
  )
}

export { CustomSwitch }
